import styles from "./TabHeader.module.scss";
import React from "react";
import classNames from "classnames";

const TabWidgets = ({children, className}) => {
    return <div className={classNames(styles['tab-widgets'], className)}>
        {children}
    </div>
};

export default TabWidgets;
